import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["buttonSize", "defaultValue", "devices", "dropdownButtonClassName", "extraDevices", "onChange"];
import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButtonGroup from 'UIComponents/button/UIButtonGroup';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import EPDeviceSelectDropdown, { TrellisEPDeviceSelectDropdown } from './EPDeviceSelectDropdown';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import { MOBILE, DESKTOP, TABLET, DEFAULT } from './internal/constants';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { withNonTrellisComponent, withTrellisComponent } from '../hoc/withTrellisComponentHOCs';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import { DesktopIcon, MobileIcon, TabletIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BUILTIN_DEVICE_TYPES = [MOBILE, DESKTOP, TABLET, DEFAULT];
const DeviceSelectIcon = ({
  iconName
}) => {
  switch (iconName) {
    case MOBILE:
      return /*#__PURE__*/_jsx(MobileIcon, {});
    case DESKTOP:
      return /*#__PURE__*/_jsx(DesktopIcon, {});
    case TABLET:
      return /*#__PURE__*/_jsx(TabletIcon, {});
    default:
      return /*#__PURE__*/_jsx(UIIcon, {
        name: iconName
      });
  }
};
const EPDeviceSelectButton = _ref => {
  let {
      buttonSize = 'small',
      defaultValue = MOBILE,
      devices = [{
        name: MOBILE
      }, {
        name: DESKTOP
      }, {
        name: TABLET
      }, {
        name: DEFAULT
      }],
      dropdownButtonClassName,
      extraDevices = [],
      onChange
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [activeButton, setActiveButton] = useState(defaultValue);
  const onClickHandler = e => {
    onChange(e);
    setActiveButton(e.target.value);
  };
  const children = devices.reduce((acc, device) => {
    let deviceName;
    let icon;
    let tooltip;
    if (typeof device === 'object') {
      deviceName = device.name;
      icon = device.icon;
      tooltip = device.tooltip;
    } else {
      deviceName = device;
    }
    if (BUILTIN_DEVICE_TYPES.includes(deviceName) || tooltip && icon) {
      let comp;
      if (rest.isTrellisCompatibleComponent) {
        comp = /*#__PURE__*/_jsx(IconButton, Object.assign({
          active: activeButton === deviceName,
          "data-test-id": `toggle-${deviceName}-button`,
          size: buttonSize,
          use: "tertiary-light",
          value: deviceName,
          tooltip: tooltip || /*#__PURE__*/_jsx(FormattedMessage, {
            message: `epDeviceSelectButton.${deviceName}`
          }),
          onClick: e => onClickHandler(SyntheticEvent(deviceName, e))
        }, rest.iconButtonStyles, {
          children: /*#__PURE__*/_jsx(DeviceSelectIcon, {
            iconName: icon || deviceName
          })
        }), deviceName);
      } else {
        comp = /*#__PURE__*/_jsx(UIIconButton, {
          active: activeButton === deviceName,
          "data-test-id": `toggle-${deviceName}-button`,
          size: buttonSize,
          className: rest.buttonClassName,
          use: "tertiary-light",
          value: deviceName,
          tooltip: tooltip || /*#__PURE__*/_jsx(FormattedMessage, {
            message: `epDeviceSelectButton.${deviceName}`
          }),
          onClick: e => onClickHandler(SyntheticEvent(deviceName, e)),
          children: /*#__PURE__*/_jsx("div", {
            style: deviceName === TABLET ? {
              fontSize: 16
            } : {},
            children: /*#__PURE__*/_jsx(UIIcon, {
              name: icon || deviceName
            })
          })
        }, deviceName);
      }
      acc.push(comp);
    }
    return acc;
  }, []);
  if (rest.isTrellisCompatibleComponent) {
    const {
      tokenProps
    } = filterTokenProps(rest);
    return /*#__PURE__*/_jsx(ButtonGroup, Object.assign({}, tokenProps, {
      children: /*#__PURE__*/_jsxs(Flex, {
        children: [children, /*#__PURE__*/_jsx(TrellisEPDeviceSelectDropdown, {
          buttonSize: buttonSize,
          devices: extraDevices
          // TODO: Migrate off of this
          ,
          dropdownButtonClassName: dropdownButtonClassName,
          onChange: onClickHandler,
          selectedDevice: activeButton
        })]
      })
    }));
  }
  return /*#__PURE__*/_jsxs(UIButtonGroup, {
    className: rest.className,
    children: [children, /*#__PURE__*/_jsx(EPDeviceSelectDropdown, {
      buttonSize: buttonSize,
      devices: extraDevices,
      dropdownButtonClassName: dropdownButtonClassName,
      onChange: onClickHandler,
      selectedDevice: activeButton
    })]
  });
};
export const LegacyEpDeviceSelectButton = withNonTrellisComponent()(EPDeviceSelectButton);
export const TrellisEpDeviceSelectButton = withTrellisComponent()(EPDeviceSelectButton);
export default LegacyEpDeviceSelectButton;